import { createListenerMiddleware } from "@reduxjs/toolkit";
import type { Combination, Product, SmartNumberMapping } from "@/features/sub-families/types";
import { getCombinationFromProduct } from "@/lib/product.ts";
import { filterOptionsSetCombinationsAction } from "@/redux/slices/filter-options-slice.ts";
import { productsSetCurrentProductReferenceAction } from "@/redux/slices/products-slice.ts";
import type { AppDispatch, RootState } from "@/redux/store.ts";

const filterCombinationsMiddleware = createListenerMiddleware();

/**
 * Creates the unique combinations for the product whenever the active product changes (because these are unique per product)
 */
filterCombinationsMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: productsSetCurrentProductReferenceAction,
    effect: (_, api) => {
        const state = api.getState();
        const products = state.products.items;
        const smartNumberMapping = state.smartNumber.mapping;

        if (!smartNumberMapping) return;

        const combinations = Object.values(products).map<Combination>(createCombination(smartNumberMapping));

        api.dispatch(filterOptionsSetCombinationsAction(combinations));
    },
});

export default filterCombinationsMiddleware.middleware;

function createCombination(smartNumberMapping: SmartNumberMapping) {
    return (product: Product) => getCombinationFromProduct(product, smartNumberMapping);
}
